import { useEffect, useState } from "react";

import { SelectChangeEvent } from "@mui/material";

import FiltersDropDown from "components/dropdowns/filtersDropDown";
import { filtersStyles } from "features/orders/index.styles";
import { DropdownTypes, DropDownList } from "utils/types";
import { useDispatch, useSelector } from "store";
import { setSelectedBranch } from "store/slices/Dropdown";

const BranchFilter = ({
  applyFilter,
  disabled,
  filtersCallback,
}: DropdownTypes) => {
  const dispatch = useDispatch(),
    [branches, setBranches] = useState<DropDownList[]>([]),
    [branchName, setBranchName] = useState<string[]>(["All Branches"]),
    { selectedBranch } = useSelector((reduxState) => reduxState.dropdown);

  const { businessBranchesAccess } = useSelector(
    (state) => state.businessBranches
  );

  //======================================= useEffect Hooks =======================================//

  useEffect(() => {
    setBranches(businessBranchesAccess);
  }, []);

  useEffect(() => {
    if (selectedBranch[0]) {
      const selectedBranchLabel = branches?.filter(
        (branch: { label: string; value: string }) => {
          if (branch.value == selectedBranch[0]) {
            return branch.label;
          }
        }
      );

      setBranchName([selectedBranchLabel[0]?.label]);
    }
  }, [branches]);

  //======================================= Handler Functions =======================================//

  //  branch filter handler
  const handleBranchFilterChange = (
    event: SelectChangeEvent<typeof branchName>
  ) => {
    const {
      target: { value },
    } = event;

    let selectedBranchResult: string[] = [];

    if (value && Array.isArray(value) && value.length) {
      // removing falsy values
      const filteredData = value.filter((element) => element);

      if (filteredData.length > 1) {
        /**
         * if => remove 'All branches' on selection of any other branch
         * else if => remove other branches on selection of 'All branches'
         * else => other branches only
         */
        if (filteredData[0] === "All Branches") {
          selectedBranchResult = filteredData?.filter(
            (branchName) => branchName !== "All Branches"
          );
        } else if (filteredData.some((branch) => branch === "All Branches")) {
          selectedBranchResult = ["All Branches"];
        } else {
          selectedBranchResult = filteredData?.filter(
            (branchName) => branchName !== "Select Branch"
          );
        }
      } else {
        selectedBranchResult = filteredData;
      }
    } else {
      selectedBranchResult = ["Select Branch"];
    }

    // setting value for filter component
    setBranchName(selectedBranchResult);

    // setting branch ids for API payload
    const branchIds = branches?.length
      ? branches.reduce((branchIds: string[], branch) => {
          if (
            selectedBranchResult?.some(
              (branchName) => branchName === branch.label
            )
          ) {
            branchIds.push(branch.value);
          }
          return branchIds;
        }, [])
      : [];

    // setting value in store for API
    dispatch(setSelectedBranch(branchIds));
  };

  // if (error) return <span>Getting Branches Failed</span>;

  return (
    <FiltersDropDown
      disabled={disabled}
      value={branchName}
      onChange={handleBranchFilterChange}
      dropDownList={branches}
      sx={filtersStyles}
      onChangeButton={applyFilter}
      disableButton={branchName[0] === "Select Branch"}
    />
  );
};

export default BranchFilter;
